import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Prototype: no real auth
  };
  return <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 pt-16" data-id="element-1923">
      {/* Form side */}
      <div className="flex items-center justify-center px-6 py-16" data-id="element-1924">
        <div className="w-full max-w-sm" data-id="element-1925">
          <div className="flex items-center mb-8" data-id="element-1926">
            <img src="https://cdn.magicpatterns.com/uploads/gbY7Dn8gGgHtYDAdDbncPd/zano_logo_full1.png" alt="Zano" className="h-8 w-auto" data-id="element-1927" />
          </div>

          <h1 className="text-2xl font-bold text-zano-charcoal mb-2" data-id="element-1928">
            Welcome back
          </h1>
          <p className="text-gray-500 mb-8" data-id="element-1929">Log in to your Zano workspace.</p>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1930">
            <div data-id="element-1931">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-1932">
                Email
              </label>
              <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-zano-pink/40 focus:border-zano-pink" data-id="element-1933" />
            </div>
            <div data-id="element-1934">
              <div className="flex items-center justify-between mb-1.5" data-id="element-1935">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-1936">
                  Password
                </label>
                <a href="#" className="text-xs font-medium text-zano-pink hover:underline" data-id="element-1937">
                  Forgot password?
                </a>
              </div>
              <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="w-full rounded-lg border border-gray-300 px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-zano-pink/40 focus:border-zano-pink" data-id="element-1938" />
            </div>
            <Button variant="primary" type="submit" className="w-full justify-center py-2.5" data-id="element-1939">
              Log in
            </Button>
          </form>

          <div className="flex items-center gap-3 my-6" data-id="element-1940">
            <div className="h-px flex-1 bg-gray-200" data-id="element-1941" />
            <span className="text-xs text-gray-400" data-id="element-1942">or</span>
            <div className="h-px flex-1 bg-gray-200" data-id="element-1943" />
          </div>

          <Button variant="secondary" className="w-full justify-center py-2.5 !text-gray-700 !border-gray-300 hover:!bg-gray-50" data-id="element-1944">
            <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="" className="w-4 h-4 mr-2" data-id="element-1945" />
            Continue with Google
          </Button>

          <p className="text-center text-sm text-gray-500 mt-8" data-id="element-1946">
            New to Zano?{' '}
            <Link to="/pricing" className="font-medium text-zano-pink hover:underline" data-id="element-1947">
              Request a demo
            </Link>
          </p>
        </div>
      </div>

      {/* Brand panel */}
      <div className="hidden lg:flex relative items-center justify-center bg-gradient-to-br from-zano-blush via-white to-zano-lavender overflow-hidden" data-id="element-1948">
        <div className="absolute top-10 right-10 w-72 h-72 bg-zano-pink/10 rounded-full blur-3xl" data-id="element-1949" />
        <div className="relative z-10 max-w-md px-10" data-id="element-1950">
          <h2 className="text-3xl font-bold text-zano-charcoal mb-4 leading-tight" data-id="element-1951">
            The Creator Asset OS for modern teams
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-1952">
            Source, license, and activate creator content from one connected
            workflow.
          </p>
          <div className="bg-white rounded-2xl border border-gray-100 shadow-float p-5" data-id="element-1953">
            <div className="flex items-center gap-3 mb-4" data-id="element-1954">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=80&q=80" alt="" className="w-11 h-11 rounded-full object-cover" data-id="element-1955" />
              <div data-id="element-1956">
                <p className="font-semibold text-gray-900 text-sm" data-id="element-1957">
                  Elena Rodriguez
                </p>
                <p className="text-xs text-gray-500" data-id="element-1958">
                  Select Mgmt • Live profile
                </p>
              </div>
            </div>
            <div className="space-y-2" data-id="element-1959">
              {['Media kit up to date', 'Rights tracked', 'Brief generated'].map(t => <div key={t} className="flex items-center gap-2 text-sm text-gray-700" data-id="element-1960">
                  <CheckCircle2 size={15} className="text-green-500" data-id="element-1961" /> {t}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
};